module.exports = __webpack_public_path__ + "img/katarina_bedrooms_29.16cd1306.jpg";